import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import myImage from "../assets/img/logo.png";
import { useAuth } from "../context/AuthContext";


export default function Login() {
  const { login } = useAuth();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: ""
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Correo inválido")
        .required("Campo obligatorio"),
      password: Yup.string()
        .min(4, "Mínimo 4 caracteres")
        .required("Campo obligatorio"),
    }),
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_DOMINIO}/wp-json/jwt-auth/v1/token`,
          {
            username: values.email,
            password: values.password
          }
        );

        if (res.data?.token) {
          localStorage.setItem("token", res.data.token); // Guarda el token
          login(res.data); // Guarda el usuario en el contexto
        } else {
          setErrors({ password: "Credenciales incorrectas" });
        }
      } catch (error) {
        console.error(error);
        setErrors({ password: "Error al conectar con el servidor" });
      } finally {
        setSubmitting(false);
      }
    }
  });

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={formik.handleSubmit}>
        <div className="login-brand">
          <img src={myImage} alt="Logo" width={250} />
        </div>
        <div className="login-inputs">
          <div >
            <label htmlFor="email">Correo:</label>
            <input
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.email && formik.errors.email && (
              <p style={{ color: "red" }}>{formik.errors.email}</p>
            )}
          </div>

          <div>
            <label htmlFor="password">Contraseña:</label>
            <input
              type="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.password && formik.errors.password && (
              <p style={{ color: "red" }}>{formik.errors.password}</p>
            )}
          </div>
        </div>

        <button className="gastos-btn gastos-btn-primary" type="submit" disabled={formik.isSubmitting}>
          {formik.isSubmitting ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
